/**
 * @generated SignedSource<<fc29928ab292ff57cb15f88f10c81bb5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type resetLearnProgressButton_LearnOpportunityV2Fragment$data = {
  readonly id: string;
  readonly structureDefinition: {
    readonly title: string;
  };
  readonly " $fragmentType": "resetLearnProgressButton_LearnOpportunityV2Fragment";
};
export type resetLearnProgressButton_LearnOpportunityV2Fragment$key = {
  readonly " $data"?: resetLearnProgressButton_LearnOpportunityV2Fragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"resetLearnProgressButton_LearnOpportunityV2Fragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "resetLearnProgressButton_LearnOpportunityV2Fragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "structureDefinition",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "LearnOpportunityV2",
  "abstractKey": null
};

(node as any).hash = "f5c8480b6e51b56c02902c8d34b5d7be";

export default node;
